/**
 * Route for `cordova-ionic-sdk`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CordovaIonicSdkPage } from "../features/cordova-ionic-sdk/CordovaIonicSdkPage";

export const cordovaIonicSdkRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cordova-ionic-sdk",
	component: CordovaIonicSdkPage,
});

export default cordovaIonicSdkRoute;
